import { render, staticRenderFns } from "./AdminRelatorios.vue?vue&type=template&id=3510ab1f"
import script from "./AdminRelatorios.vue?vue&type=script&lang=js"
export * from "./AdminRelatorios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports